import { PropsWithChildren, ReactNode, forwardRef } from 'react';
import Devider, { DeviderTagType, DeviderVariant } from './layout/Devider';
import * as stylex from '@stylexjs/stylex';
import type { StyleXStyles } from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
import { stylexProps } from '@/util/stylexProps';
type Props = PropsWithChildren<{
  id?: string;
  style?: StyleXStyles;
  className?: string;
  standardPadding?: boolean;
  deviderText?: string;
  variant?: DeviderVariant;
  deviderTagType?: DeviderTagType;
  header?: ReactNode | undefined;
  href?: string;
  prefetch?: boolean | 'auto' | null;
  noBorderDesktop?: boolean;
}>;
const PFSection = forwardRef<HTMLElement, Props>((props: Props, ref) => {
  const {
    standardPadding,
    style,
    className,
    id,
    deviderText,
    variant = 'bigDevider',
    deviderTagType,
    header,
    href,
    prefetch,
    noBorderDesktop
  } = props;
  return <section {...stylexProps(className, styles.root, standardPadding && styles.standardPadding, variant === 'pinkSection' && styles.pink, style)} ref={ref}>
      <div className="x10l6tqk x16k8lb1 xqu0tyb x16sl8bf" id={id} />
      {deviderText && <Devider variant={variant} lightBorder noBorderDesktop={noBorderDesktop} title={deviderText} tagType={deviderTagType} header={header} href={href} prefetch={prefetch} />}
      {props.children}
    </section>;
});
PFSection.displayName = 'Section';
const styles = {
  root: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  standardPadding: {
    kmVPX3: "x1qhigcl x1hfp7zh",
    kYLs0V: "x1p7q5un",
    $$css: true
  },
  pink: {
    kWkggS: "x3r82pw",
    $$css: true
  }
};
export default PFSection;